document.addEventListener('DOMContentLoaded', () => {
  const threshold = 5500;

  async function updateTfibAnnouncementShipping() {
    const announcement = document.querySelector('#TfibAnnouncementShipping');

    if (!announcement) return;

    try {
      const response = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        }
      });

      const cart = await response.json();

      const isFrench = document.documentElement.lang.toLowerCase().startsWith('fr');

if (cart.total_price >= threshold) {
  announcement.innerHTML = isFrench
    ? `✓ Vous avez débloqué la <strong>livraison gratuite !</strong> ✨`
    : `✓ You've unlocked <strong>FREE shipping!</strong> ✨`;
} else {
  const remaining = threshold - cart.total_price;

  const formattedRemaining = new Intl.NumberFormat(
    document.documentElement.lang || 'en-CA',
    {
      style: 'currency',
      currency: cart.currency || 'CAD'
    }
  ).format(remaining / 100);

  announcement.innerHTML = isFrench
    ? `🚚 Seulement <strong>${formattedRemaining}</strong> pour profiter de la livraison gratuite ✨`
    : `🚚 Only <strong>${formattedRemaining}</strong> away from free shipping ✨`;
}
    } catch (error) {
      console.error('TFIB shipping announcement error:', error);
    }
  }

  // Initial calculation
  updateTfibAnnouncementShipping();

  // Watch cart drawer AJAX changes
  const cartDrawer = document.querySelector('cart-drawer');

  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      clearTimeout(window.tfibShippingTimer);

      window.tfibShippingTimer = setTimeout(() => {
        updateTfibAnnouncementShipping();
      }, 150);
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }

  // Watch cart count changes
  const cartIcon = document.querySelector('#cart-icon-bubble');

  if (cartIcon) {
    const cartObserver = new MutationObserver(() => {
      clearTimeout(window.tfibShippingTimer);

      window.tfibShippingTimer = setTimeout(() => {
        updateTfibAnnouncementShipping();
      }, 150);
    });

    cartObserver.observe(cartIcon, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});